import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";
import { IconButton, ListItemIcon, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useState, type ReactNode } from "react";

interface Props {
  title: string;
  actions?: ReactNode;
  addingActive: boolean;
  onToggleAdding?: () => void;
}

const FieldContainerHeading = ({ title, actions, addingActive, onToggleAdding }: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Typography variant="subtitle2" sx={{ flex: 1 }}>
        {title}
      </Typography>
      {actions}
      {onToggleAdding && (
        <>
          <IconButton
            aria-label={`${title} options`}
            aria-haspopup="menu"
            aria-expanded={!!anchorEl}
            onClick={(event) => setAnchorEl(event.currentTarget)}
          >
            <MoreHorizRoundedIcon />
          </IconButton>
          <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)}>
            <MenuItem
              onClick={() => {
                onToggleAdding();
                setAnchorEl(undefined);
              }}
            >
              <ListItemIcon>{addingActive ? <DoneRoundedIcon /> : <MyLocationRoundedIcon />}</ListItemIcon>
              {addingActive ? "Finish adding fields" : "Add fields here"}
            </MenuItem>
          </Menu>
        </>
      )}
    </Stack>
  );
};

export default FieldContainerHeading;
